import { render, staticRenderFns } from "./account.vue?vue&type=template&id=5b81964a&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"
import style0 from "./account.vue?vue&type=style&index=0&id=5b81964a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81964a",
  null
  
)

export default component.exports